export default "__VITE_ASSET__CfVo3ygZ__"